/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PressureUnit } from './PressureUnit';
import {
    PressureUnitFromJSON,
    PressureUnitFromJSONTyped,
    PressureUnitToJSON,
} from './PressureUnit';

/**
 * 
 * @export
 * @interface Pressure
 */
export interface Pressure {
    /**
     * 
     * @type {number}
     * @memberof Pressure
     */
    value?: number;
    /**
     * 
     * @type {PressureUnit}
     * @memberof Pressure
     */
    unit?: PressureUnit;
    /**
     * 
     * @type {string}
     * @memberof Pressure
     */
    $type?: PressureTypeEnum;
}


/**
 * @export
 */
export const PressureTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type PressureTypeEnum = typeof PressureTypeEnum[keyof typeof PressureTypeEnum];



/**
 * Check if a given object implements the Pressure interface.
 */
export function instanceOfPressure(value?: unknown): value is Pressure {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PressureTypeEnum)[0];
}

export function PressureFromJSON(json: any): Pressure {
    return PressureFromJSONTyped(json, false);
}

export function PressureFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pressure {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'unit': json['unit'] == null ? undefined : PressureUnitFromJSON(json['unit']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PressureToJSON(value?: Pressure | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value['value'],
        'unit': PressureUnitToJSON(value['unit']),
        '$type': value['$type'],
    });
}

